import { ProductDoc } from '@gooduncles/gu-app-schema';
import { useCallback, useMemo } from 'react';
import { getAlgoliaIndex } from 'src/utils/algoliasearch-util';
import { facetFilters } from 'src/utils/constants/service-constants';
import useSWRInfinite from 'swr/infinite';

const hitsPerPage = 20;

/**
 * 무한 스크롤 처리를 위한 훅
 * : setSize 함수를 통해 다음 페이지를 요청합니다.
 */
const useInifiniteAlgoliaSearch = (query: string, restrictSearchableAttributes?: string[], sortKeyKr?: string) => {
  const algoliaIndex = useMemo(() => getAlgoliaIndex(sortKeyKr), [sortKeyKr]);

  const queryWithIndexing = useCallback((page: number) => `${query}/${sortKeyKr}/page@${page}`, [query, sortKeyKr]);
  const fetcher = useCallback(
    (value: string) => {
      const page = Number(value.split('@')[1] ?? 0);
      return algoliaIndex.search<ProductDoc>(query, {
        hitsPerPage,
        page,
        facetFilters,
        restrictSearchableAttributes,
      });
    },
    [algoliaIndex, query, restrictSearchableAttributes]
  );
  const { data, size, setSize, isLoading } = useSWRInfinite(queryWithIndexing, fetcher);

  return {
    hits: data?.flatMap((item) => item.hits) ?? [],
    totalPages: data?.[data.length - 1]?.nbPages ?? 0,
    totalHits: data?.[data.length - 1]?.nbHits ?? 0,
    isLoading,
    size,
    setSize,
  };
};

export default useInifiniteAlgoliaSearch;
